import {FinanceState, MortgageOverview, Scenario} from './AppState';

export function newScenarioId(state: FinanceState): string {
  const lastId = lastScenarioId(state);

  if (lastId == null) {
    return '0';
  } else {
    return String(+lastId + 1);
  }
}

export function lastScenario(state: FinanceState): Scenario | null {
  const lastId = lastScenarioId(state);
  if (null == lastId) {
    return null;
  } else {
    return state.scenarios[lastId];
  }
}

export function lastScenarioId(state: FinanceState): string | null {
  if (state.scenarios == null) {
    return null;
  } else {
    const keys = Object.keys(state.scenarios);
    if (keys.length === 0) {
      return null;
    } else {
      return keys[keys.length - 1];
    }
  }
}

export function newMortgageId(scenario: Scenario): string {
  const lastId = lastMortgageId(scenario);

  if (lastId == null) {
    return '0';
  } else {
    return String(+lastId + 1);
  }
}


export function newPaymentId(mortgage: MortgageOverview): string {
  const lastId = lastPaymentId(mortgage);

  if (lastId == null) {
    return '0';
  } else {
    return String(+lastId + 1);
  }
}

export function lastPaymentId(mortgage: MortgageOverview): string | null {
  const keys = Object.keys(mortgage.payments);
  if (keys.length === 0) {
    return null;
  } else {
    return keys[keys.length - 1];
  }
}


export function lastMortgageId(scenario: Scenario): string | null {
  if (scenario.mortgages == null) {
    return null;
  } else {
    const keys = Object.keys(scenario.mortgages);
    if (keys.length === 0) {
      return null;
    } else {
      return keys[keys.length - 1];
    }
  }
}
